// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./data/header-banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* #root {
  text-align: center;
  height: 100%;
} */
* {
  box-sizing: border-box;
}

html {
  width: 100%;
  height: 100%;
}
#root {
  /* display: block;
  position: absolute; */
  /* background-image: url("https://i.pinimg.com/originals/e3/af/f8/e3aff803532ba650bfa072f6544dc33a.jpg"); */
  /* width: 100%;
  height: 100%; */
}

/* #root:before {
  content: "";
  position: absolute;
  background-image: url("https://i.pinimg.com/originals/e3/af/f8/e3aff803532ba650bfa072f6544dc33a.jpg");
  width: 100vw;
  height: 100vh;
  background-repeat: repeat-x repeat-y;
  background-position: 50% 0;
  opacity: 0.5;
  z-index: -1;
} */

header {
  width: 100%;
  height: 350px;
  border: 1px solid;
  background: black;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: 10% 25%;
  background-size: 125%;
}

main {
  font-family: "Nunito", sans-serif;
  width: 100%;
  /* background: white; */
}

li {
  list-style: none;
}

.App-logo {
  animation: App-logo-spin infinite 20s linear;
  height: 40vmin;
  pointer-events: none;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 1024px) {
  header {
    background-size: 1500px 1000px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;GAGG;AAGH;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE;uBACqB;EACrB,2GAA2G;EAC3G;iBACe;AACjB;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,iBAAiB;EACjB,yDAAiD;EACjD,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* #root {\n  text-align: center;\n  height: 100%;\n} */\n\n@import url(\"https://fonts.googleapis.com/css2?family=Nunito&display=swap\");\n* {\n  box-sizing: border-box;\n}\n\nhtml {\n  width: 100%;\n  height: 100%;\n}\n#root {\n  /* display: block;\n  position: absolute; */\n  /* background-image: url(\"https://i.pinimg.com/originals/e3/af/f8/e3aff803532ba650bfa072f6544dc33a.jpg\"); */\n  /* width: 100%;\n  height: 100%; */\n}\n\n/* #root:before {\n  content: \"\";\n  position: absolute;\n  background-image: url(\"https://i.pinimg.com/originals/e3/af/f8/e3aff803532ba650bfa072f6544dc33a.jpg\");\n  width: 100vw;\n  height: 100vh;\n  background-repeat: repeat-x repeat-y;\n  background-position: 50% 0;\n  opacity: 0.5;\n  z-index: -1;\n} */\n\nheader {\n  width: 100%;\n  height: 350px;\n  border: 1px solid;\n  background: black;\n  background-image: url(\"./data/header-banner.jpg\");\n  background-position: 10% 25%;\n  background-size: 125%;\n}\n\nmain {\n  font-family: \"Nunito\", sans-serif;\n  width: 100%;\n  /* background: white; */\n}\n\nli {\n  list-style: none;\n}\n\n.App-logo {\n  animation: App-logo-spin infinite 20s linear;\n  height: 40vmin;\n  pointer-events: none;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 1024px) {\n  header {\n    background-size: 1500px 1000px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
